import InternetImg from "public/network-services/icons/internet-dci.png";
import SocImg from "public/network-services/icons/noc-soc-helpdesk.png";
import MonitoringImg from "public/network-services/monitoring.svg";

export const ADVANTAGES_CONSTANTS = [
  {
    image: InternetImg,
    title: "Consulting-Led Design",
    text: "Modernize legacy systems or launch new sites with infrastructure blueprints tailored by experts to match your business vision.",
  },
  {
    image: SocImg,
    title: "Secure & Scalable Foundations",
    text: "Build future-ready networks that deliver security, scalability, and long-term agility—aligned with your goals from day one.",
  },
  {
    image: MonitoringImg,
    title: "End-to-End Optimization",
    text: "From planning to deployment and beyond, ensure continuous optimization for resilience, seamless connectivity, and adaptability.",
  },
];
